import React from 'react';
export function BookMockup() {
  return <div className="w-full flex justify-center" data-id="element-41">
      <img src="https://cdn.magicpatterns.com/uploads/uJDDPDaWivg7FUVfiTtqhR/portada.png" alt="Venezuela — The truth the world ignored" className="w-full h-auto rounded-lg transition-transform duration-500 hover:scale-[1.03]" style={{
      boxShadow: '0 25px 50px rgba(0, 0, 0, 0.8), 0 15px 30px rgba(0, 0, 0, 0.6), 0 0 60px rgba(212, 168, 90, 0.18)'
    }} data-id="element-42" />
    </div>;
}